import { render, staticRenderFns } from "./RigthComponentFight.vue?vue&type=template&id=79789c4c&scoped=true&"
import script from "./RigthComponentFight.vue?vue&type=script&lang=js&"
export * from "./RigthComponentFight.vue?vue&type=script&lang=js&"
import style0 from "./RigthComponentFight.vue?vue&type=style&index=0&id=79789c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79789c4c",
  null
  
)

export default component.exports